// Remembered "rows per page" for the BO order list (/backoffice/orders).
// Spec: docs/specs/2026-10-07-bo-orders-pagination-size-design.md §3 P1-P3.
//
// WHY localStorage AND NOT THE URL. /backoffice/orders is a QUERY_KEYED_PATH
// of the taskbar: a new query string opens a NEW taskbar tab. So the page size
// must never be written to `$route.query` (P4) -- it lives here instead.
//
// No vue import and the storage is passed in, so tests/unit/pageSizePref.spec.js
// can drive it with a fake. Neither function ever throws: a browser with
// storage disabled (private mode, quota, SecurityError) just gets the default.

import { normalizeSize } from './ordersNew';

export const ORDERS_PAGE_SIZE_KEY = 'mdf.orders.page_size';

/** Stored size if it is one of PAGE_SIZES (10/20/50/100), else `fallback`. */
export function readPageSize(storage, key, fallback = 10) {
  let raw = null;
  try {
    raw = storage && typeof storage.getItem === 'function' ? storage.getItem(key) : null;
  } catch (e) {
    return fallback;
  }
  if (raw === null || raw === undefined || raw === '') return fallback;
  // normalizeSize maps anything outside PAGE_SIZES to PAGE_SIZE (10); only a
  // value that really is in the list may override `fallback`.
  const n = normalizeSize(raw);
  return String(n) === String(raw).trim() ? n : fallback;
}

/** Store `size` (normalized). true when written, false when storage refused. */
export function writePageSize(storage, key, size) {
  try {
    if (!storage || typeof storage.setItem !== 'function') return false;
    storage.setItem(key, String(normalizeSize(size)));
    return true;
  } catch (e) {
    return false;
  }
}
